// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin panel — light/dark via html.dark (filevault-theme: system | light | dark) */

.admin-scope {
  --adm-bg: #ffffff;
  --adm-surface: #ffffff;
  --adm-surface-muted: #f1f5f9;
  --adm-surface-elevated: #ffffff;
  --adm-border: #e2e8f0;
  --adm-border-subtle: #f1f5f9;
  --adm-text: #0f172a;
  --adm-text-muted: #64748b;
  --adm-text-faint: #94a3b8;
  --adm-hover: #ffffff;
  --adm-divide: #e2e8f0;
  --adm-input-bg: #ffffff;
  --adm-overlay: rgba(15, 23, 42, 0.5);
  color: var(--adm-text);
  transition: background-color 0.2s ease, color 0.2s ease;
}

html.dark .admin-scope {
  --adm-bg: #020617;
  --adm-surface: #1e293b;
  --adm-surface-muted: #334155;
  --adm-surface-elevated: #1e293b;
  --adm-border: #475569;
  --adm-border-subtle: #334155;
  --adm-text: #f1f5f9;
  --adm-text-muted: #94a3b8;
  --adm-text-faint: #64748b;
  --adm-hover: #334155;
  --adm-divide: #475569;
  --adm-input-bg: #0f172a;
  --adm-overlay: rgba(2, 6, 23, 0.75);
  color-scheme: dark;
}

.admin-scope.admin-panel-page {
  background-color: var(--adm-bg);
  min-height: 100%;
}

/* Surfaces */
.admin-scope .bg-white {
  background-color: var(--adm-surface) !important;
}

.admin-scope .bg-white\\/80,
.admin-scope .bg-white\\/90 {
  background-color: color-mix(in srgb, var(--adm-surface) 88%, transparent) !important;
}

.admin-scope .bg-gray-50,
.admin-scope .bg-slate-50,
.admin-scope .bg-slate-50\\/80 {
  background-color: var(--adm-surface-muted) !important;
}

.admin-scope .bg-gray-100,
.admin-scope .bg-slate-100 {
  background-color: var(--adm-hover) !important;
}

.admin-scope .hover\\:bg-gray-50:hover,
.admin-scope .hover\\:bg-slate-50:hover,
.admin-scope .hover\\:bg-slate-50\\/80:hover,
.admin-scope .hover\\:bg-slate-100:hover {
  background-color: var(--adm-hover) !important;
}

/* Borders */
.admin-scope .border-gray-100,
.admin-scope .border-gray-200,
.admin-scope .border-gray-300,
.admin-scope .border-slate-100,
.admin-scope .border-slate-200,
.admin-scope .border-blue-100\\/50 {
  border-color: var(--adm-border) !important;
}

.admin-scope .divide-gray-200 > :not([hidden]) ~ :not([hidden]),
.admin-scope .divide-slate-200 > :not([hidden]) ~ :not([hidden]),
.admin-scope .divide-slate-100 > :not([hidden]) ~ :not([hidden]) {
  border-color: var(--adm-divide) !important;
}

/* Text */
.admin-scope .text-gray-900,
.admin-scope .text-gray-800,
.admin-scope .text-gray-700,
.admin-scope .text-slate-900,
.admin-scope .text-slate-800,
.admin-scope .text-slate-700 {
  color: var(--adm-text) !important;
}

.admin-scope .text-gray-600,
.admin-scope .text-gray-500,
.admin-scope .text-slate-600,
.admin-scope .text-slate-500 {
  color: var(--adm-text-muted) !important;
}

.admin-scope .text-gray-400,
.admin-scope .text-slate-400,
.admin-scope .text-slate-300 {
  color: var(--adm-text-faint) !important;
}

/* Inputs inside legacy modals */
.admin-scope input:not([type='checkbox']):not([type='radio']),
.admin-scope select,
.admin-scope textarea {
  background-color: var(--adm-input-bg);
  color: var(--adm-text);
  border-color: var(--adm-border);
}

.admin-scope input::placeholder,
.admin-scope textarea::placeholder {
  color: var(--adm-text-faint);
}

/* Plan cards: light gradient shells in dark */
html.dark .admin-scope .from-white {
  --tw-gradient-from: var(--adm-surface) var(--tw-gradient-from-position);
}

html.dark .admin-scope .via-blue-50\\/20 {
  --tw-gradient-via: color-mix(in srgb, var(--adm-surface-muted) 20%, transparent)
    var(--tw-gradient-via-position);
}

html.dark .admin-scope .to-purple-50\\/20 {
  --tw-gradient-to: color-mix(in srgb, var(--adm-surface-muted) 20%, transparent)
    var(--tw-gradient-to-position);
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/adminTheme.css"],"names":[],"mappings":"AAAA,oFAAoF;;AAEpF;EACE,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,oCAAoC;EACpC,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,+CAA+C;AACjD;;AAEA;;EAEE,oFAAoF;AACtF;;AAEA;;;EAGE,qDAAqD;AACvD;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;;;;EAIE,6CAA6C;AAC/C;;AAEA,YAAY;AACZ;;;;;;EAME,0CAA0C;AAC5C;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA,SAAS;AACT;;;;;;EAME,iCAAiC;AACnC;;AAEA;;;;EAIE,uCAAuC;AACzC;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA,gCAAgC;AAChC;;;EAGE,qCAAqC;EACrC,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA,8CAA8C;AAC9C;EACE,uEAAuE;AACzE;;AAEA;EACE;mCACiC;AACnC;;AAEA;EACE;kCACgC;AAClC","sourcesContent":["/* Admin panel — light/dark via html.dark (filevault-theme: system | light | dark) */\n\n.admin-scope {\n  --adm-bg: #ffffff;\n  --adm-surface: #ffffff;\n  --adm-surface-muted: #f1f5f9;\n  --adm-surface-elevated: #ffffff;\n  --adm-border: #e2e8f0;\n  --adm-border-subtle: #f1f5f9;\n  --adm-text: #0f172a;\n  --adm-text-muted: #64748b;\n  --adm-text-faint: #94a3b8;\n  --adm-hover: #ffffff;\n  --adm-divide: #e2e8f0;\n  --adm-input-bg: #ffffff;\n  --adm-overlay: rgba(15, 23, 42, 0.5);\n  color: var(--adm-text);\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\nhtml.dark .admin-scope {\n  --adm-bg: #020617;\n  --adm-surface: #1e293b;\n  --adm-surface-muted: #334155;\n  --adm-surface-elevated: #1e293b;\n  --adm-border: #475569;\n  --adm-border-subtle: #334155;\n  --adm-text: #f1f5f9;\n  --adm-text-muted: #94a3b8;\n  --adm-text-faint: #64748b;\n  --adm-hover: #334155;\n  --adm-divide: #475569;\n  --adm-input-bg: #0f172a;\n  --adm-overlay: rgba(2, 6, 23, 0.75);\n  color-scheme: dark;\n}\n\n.admin-scope.admin-panel-page {\n  background-color: var(--adm-bg);\n  min-height: 100%;\n}\n\n/* Surfaces */\n.admin-scope .bg-white {\n  background-color: var(--adm-surface) !important;\n}\n\n.admin-scope .bg-white\\/80,\n.admin-scope .bg-white\\/90 {\n  background-color: color-mix(in srgb, var(--adm-surface) 88%, transparent) !important;\n}\n\n.admin-scope .bg-gray-50,\n.admin-scope .bg-slate-50,\n.admin-scope .bg-slate-50\\/80 {\n  background-color: var(--adm-surface-muted) !important;\n}\n\n.admin-scope .bg-gray-100,\n.admin-scope .bg-slate-100 {\n  background-color: var(--adm-hover) !important;\n}\n\n.admin-scope .hover\\:bg-gray-50:hover,\n.admin-scope .hover\\:bg-slate-50:hover,\n.admin-scope .hover\\:bg-slate-50\\/80:hover,\n.admin-scope .hover\\:bg-slate-100:hover {\n  background-color: var(--adm-hover) !important;\n}\n\n/* Borders */\n.admin-scope .border-gray-100,\n.admin-scope .border-gray-200,\n.admin-scope .border-gray-300,\n.admin-scope .border-slate-100,\n.admin-scope .border-slate-200,\n.admin-scope .border-blue-100\\/50 {\n  border-color: var(--adm-border) !important;\n}\n\n.admin-scope .divide-gray-200 > :not([hidden]) ~ :not([hidden]),\n.admin-scope .divide-slate-200 > :not([hidden]) ~ :not([hidden]),\n.admin-scope .divide-slate-100 > :not([hidden]) ~ :not([hidden]) {\n  border-color: var(--adm-divide) !important;\n}\n\n/* Text */\n.admin-scope .text-gray-900,\n.admin-scope .text-gray-800,\n.admin-scope .text-gray-700,\n.admin-scope .text-slate-900,\n.admin-scope .text-slate-800,\n.admin-scope .text-slate-700 {\n  color: var(--adm-text) !important;\n}\n\n.admin-scope .text-gray-600,\n.admin-scope .text-gray-500,\n.admin-scope .text-slate-600,\n.admin-scope .text-slate-500 {\n  color: var(--adm-text-muted) !important;\n}\n\n.admin-scope .text-gray-400,\n.admin-scope .text-slate-400,\n.admin-scope .text-slate-300 {\n  color: var(--adm-text-faint) !important;\n}\n\n/* Inputs inside legacy modals */\n.admin-scope input:not([type='checkbox']):not([type='radio']),\n.admin-scope select,\n.admin-scope textarea {\n  background-color: var(--adm-input-bg);\n  color: var(--adm-text);\n  border-color: var(--adm-border);\n}\n\n.admin-scope input::placeholder,\n.admin-scope textarea::placeholder {\n  color: var(--adm-text-faint);\n}\n\n/* Plan cards: light gradient shells in dark */\nhtml.dark .admin-scope .from-white {\n  --tw-gradient-from: var(--adm-surface) var(--tw-gradient-from-position);\n}\n\nhtml.dark .admin-scope .via-blue-50\\/20 {\n  --tw-gradient-via: color-mix(in srgb, var(--adm-surface-muted) 20%, transparent)\n    var(--tw-gradient-via-position);\n}\n\nhtml.dark .admin-scope .to-purple-50\\/20 {\n  --tw-gradient-to: color-mix(in srgb, var(--adm-surface-muted) 20%, transparent)\n    var(--tw-gradient-to-position);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
